<template>
  <div>
    <b-form-group id="input-group-email" label="Primary role" label-for="input-primary-role">
      <b-form-select v-model="role" :options="roles"></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      role: "",
      roles: [
        "Faculty member",
        "Researcher",
        "Professor",
        "Student",
        "Associate professor",
        "Lecturer",
        "Member of Professional Institute",
        "Librarian",
        "Reviewer",
        "Editor",
        "Government Official",
        "Other"
      ]
    };
  },
  methods: {
    handleInput() {
      this.$emit("input", this.role);
    }
  }
};
</script>